import { render, staticRenderFns } from "./folderDetails.vue?vue&type=template&id=15b8e55a"
import script from "./folderDetails.vue?vue&type=script&lang=js"
export * from "./folderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports